/**
 * Created by lu on 17/2/9.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': ['form-group', nb.bind('status')],
        $html: [{
            class:"input-date date",
            $html:{
                $name: 'input',
                'class': 'form-control',
                tag: 'input',
                type: nb.bind('type'),
                value: nb.bind('value',{event:'blur change'}),
                placeholder:'年／月／日'//nb.bind('placeholder')
            }
        }]
    },
    method: {
        init: function () {
            var self = this;
            var $el = this.$();
            this.$('input').focus(function (inEvent) {
                var model = self.getModel();
                model.set('inInput', true, {
                    skipSameValue: false
                })
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/form/InputDate.js
// module id = 92
// module chunks = 1 3 12